import { CommonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RmAntibioticsReportInfo } from '../dto/rm-antibiotics-report.dto';
import { AntibioticsReportService } from './rm-antibiotics-report.service';

@ApiTags('Antibiotics Report')
@Controller('rm-antibiotics-report')
export class AnitibioticsReportController {

    constructor(
        private service: AntibioticsReportService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createAntibioticsInfo')
    async createAntibioticsInfo(@Body() info: RmAntibioticsReportInfo): Promise<CommonResponse>{
        try{
            return await this.service.createAntiBioticsTest(info);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}